module.exports = __webpack_public_path__ + "img/vinil-pe-drumul-craciunului.7903a387.jpg";